import useMediaView from "features/common/hooks/useMediaView";
import React from "react";
import DeskTableMobilePage from "./(mobile)/DeskTableMobilePage";
import DeskTableWebPage from "./(web)/DeskTableWebPage";
import useDocumentCategoriesQuery from "features/document/hooks/queries/useDocumentCategoriesQuery";
import { useParamState } from "@yoonhaemin-lib/use-param-state";
import dayjs from "dayjs";
import {
  MyDeskSearchOptions,
  MyDeskSummaryStatus,
} from "models/document/MyDeskSearchOptions";
import { useSearchParams } from "react-router-dom";
import { DOCUMENT_CATEGORY_UUID } from "config/constant";
import { DocumentMyDeskResponse } from "apis/data-contracts";

const MyPageDeskPage = () => {
  const isSmall = useMediaView("small");

  const [searchParams] = useSearchParams();

  const documentStatus =
    (searchParams.get("documentStatus") as DocumentMyDeskResponse["status"]) ||
    undefined;
  const summaryStatus =
    (searchParams.get("summaryStatus") as MyDeskSummaryStatus) || undefined;

  const [searchState, setSearchOptions] = useParamState<MyDeskSearchOptions>({
    search: "",
    startDate: "",
    endDate: "",
    selectedTab: {
      name: searchParams.get("selectedTab.name") || "WORK",
      uuid: searchParams.get("selectedTab.uuid") || DOCUMENT_CATEGORY_UUID.WORK,
    },
    documentStatus,
    summaryStatus,
    page: Number(searchParams.get("page")) || 1,
  });

  const { data } = useDocumentCategoriesQuery({
    keyword: searchState.search,
    startDate:
      searchState.startDate &&
      dayjs(searchState.startDate).format("YYYY-MM-DD"),
    endDate:
      searchState.endDate && dayjs(searchState.endDate).format("YYYY-MM-DD"),
  });

  const categories = data.data.result;

  return (
    <>
      {!isSmall && (
        <DeskTableWebPage
          categories={categories}
          searchState={searchState}
          setSearchOptions={setSearchOptions}
        />
      )}
      {isSmall && (
        <DeskTableMobilePage
          categories={categories}
          searchState={searchState}
          setSearchOptions={setSearchOptions}
        />
      )}
    </>
  );
};

export default MyPageDeskPage;
